import { combineReducers } from 'redux-immutable'
import divisionCreateReducer from './division-create-reducer'
import divisionListReducer from './division-list-reducer'
import divisionEditReducer from './division-edit-reducer'
import divisionGetReducer from './division-get-reducer'
import divisionDeactivateReducer from './division-deactivate-reducer'
import divisionExportReducer from './division-export-reducer'

export default combineReducers({
  divisionCreate: divisionCreateReducer,
  divisionList: divisionListReducer,
  divisionEdit: divisionEditReducer,
  divisionGet: divisionGetReducer,
  divisionDeactivate: divisionDeactivateReducer,
  divisionExport: divisionExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/division/index.js